/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useState } from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'

import Textarea from '@groovehq/internal-design-system/lib/components/Textarea/Textarea'
import {
  text,
  button,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'

import RoleSelection from '../RoleSelection'

const EmailsField = styled(Textarea)`
  max-width: 297px;
`

const AddUserBulk = ({ className, setValue, setSendMode }) => {
  const [role, setRole] = useState('agent')
  // Handle select role
  const handleSelectRole = useCallback(
    key => {
      setRole(key)
      setValue('bulkRole', key)
    },
    [setValue]
  )

  const handleModeChange = useCallback(() => setSendMode('rows'), [setSendMode])

  const handleFieldChange = useCallback(
    e => {
      const value = e.target.value
      setValue('bulkEmails', value)
    },
    [setValue]
  )

  return (
    <div className={className}>
      <div>
        <EmailsField
          className="grui my-7"
          rows="4"
          name="bulkEmails"
          placeholder={`name@email.com\nname@email.com\nname@email.com`}
          label=""
          onChange={handleFieldChange}
        />
        <button
          type="button"
          css={button.styles.link}
          onClick={handleModeChange}
        >
          + Add less users
        </button>
      </div>
      <div className="grui mt-12">
        <p css={[paragraph.styles.preflight, text.styles.fontMedium]}>Role</p>
        <p
          css={[paragraph.styles.preflight, text.styles.textDark]}
          className="grui mb-7"
        >
          This role will be applied to all invited users.
        </p>
        <RoleSelection onSelect={handleSelectRole} role={role} />
      </div>
    </div>
  )
}

AddUserBulk.propTypes = {
  className: string,
}

AddUserBulk.defaultProps = {
  className: undefined,
}

export default AddUserBulk
